'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthErrorPayload(message) {
  this.Lr = null;
  this.Lr = message;
}
export { $c_Lpresto_types$TwoFactorAuthErrorPayload as $c_Lpresto_types$TwoFactorAuthErrorPayload };
$p = $c_Lpresto_types$TwoFactorAuthErrorPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthErrorPayload;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthErrorPayload() {
}
export { $h_Lpresto_types$TwoFactorAuthErrorPayload as $h_Lpresto_types$TwoFactorAuthErrorPayload };
$h_Lpresto_types$TwoFactorAuthErrorPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$TwoFactorAuthErrorPayload) && (this.Lr === x$0.Lr)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "TwoFactorAuthErrorPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Lr;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$TwoFactorAuthErrorPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ko)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuthErrorPayload as $isArrayOf_Lpresto_types$TwoFactorAuthErrorPayload };
var $d_Lpresto_types$TwoFactorAuthErrorPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthErrorPayload, "presto.types$TwoFactorAuthErrorPayload", ({
  ko: 1,
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuthErrorPayload as $d_Lpresto_types$TwoFactorAuthErrorPayload };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Error-Payload.js.map
